var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.375C8.57969 3.375 3.375 8.57969 3.375 15C3.375 21.4203 8.57969 26.625 15 26.625C21.4203 26.625 26.625 21.4203 26.625 15C26.625 14.2409 26.5524 13.5002 26.4143 12.784L26.1303 11.3112L29.076 10.7431L29.3601 12.216C29.5341 13.1184 29.625 14.0493 29.625 15C29.625 23.0772 23.0772 29.625 15 29.625C6.92284 29.625 0.375 23.0772 0.375 15C0.375 6.92284 6.92284 0.375 15 0.375C18.1053 0.375 20.9886 1.34448 23.3581 2.99726L24.5884 3.85541L22.8721 6.31597L21.6419 5.45782C19.7595 4.14482 17.4719 3.375 15 3.375ZM30.2459 5.62531L29.1852 6.68597L16.0602 19.811L14.9995 20.8716L13.9389 19.811L8.31388 14.186L7.25322 13.1253L9.37454 11.004L10.4352 12.0646L14.9995 16.629L27.0639 4.56465L28.1245 3.50398L30.2459 5.62531Z",
    fill: "#2BB02B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.ad14ecd8855ef3bfd4d5271c4219c7fd.svg";
export { ForwardRef as ReactComponent };